import { Controller } from "stimulus"
import $ from 'jquery'

export default class extends Controller {
  static targets = ['resident', 'manager', 'residentForm', 'managerForm', 'communityInfo']

  connect() {
    this.handleFormVisibility()
  }

  handleFormVisibility() {
    if (this.managerTarget.checked) {
      this.managerFormTarget.classList.remove('d-none')
    }
  }

  chooseForm(event) {
    const userType = event.target.value

    if (userType === 'Resident') {
      this.onResidentCommunitySelect()
      this.managerTarget.disabled = true
      this.managerFormTarget.remove()
      this.residentFormTarget.classList.remove('d-none')
    } else if (userType === 'Community Staff') {
      this.residentTarget.disabled = true
      this.residentFormTarget.remove()
      this.managerFormTarget.classList.remove('d-none')
    }
  }

  onResidentCommunitySelect() {
    const supportController = this

    $('.select2-resident-communities').on('select2:select', function (e) {
      $.get({
        url: `/communities/${e.target.value}`,
        success: function (result) {
          supportController.communityInfoTarget.innerHTML = result
        }
      })
    })
  }
}
